module.exports = __webpack_public_path__ + "img/waistline.066b28bc.png";